import { AuthActionCreators } from "./reducers/auth/action-creators";
import { DictionaryActionCreators } from "./reducers/dictionary/action-creators";
import { LayoutActionCreators } from "./reducers/layout/action-creators";

export const actionCreators = {
    ...AuthActionCreators,
    ...LayoutActionCreators,
}
